import React from 'react';
import config from '../config/config';

const ICON_URLS = {
  keyboardArrowUp: `${config.icons.baseUrl}${config.icons.keyboardArrowUp}`,
  notes: `${config.icons.baseUrl}${config.icons.notes}`,
}
const DESCRIPTION_SHOW_SEARCH_RESULT = 'リスト表示';
/**
 * 画面下部モバイルアクションコンポーネント
 */
const MobileActions = ({
  openLongPressAtMapCenter,
  isSearchResultOpen,
  isSearchResultVisible,
  setIsSearchResultVisible
}) => {

  return (
    <div className="location-info-area-mobile-actions">

      {/* モバイルの、折り畳まれた検索結果パネルを再表示するボタン */}
      {/* 検索結果があり折り畳み状態のときに出す */}
      {isSearchResultOpen && !isSearchResultVisible && (
        <div className="show-search-result">

          <button
            type="button"
            className="show-search-result-btn"
            onClick={() => setIsSearchResultVisible(true)}
          >
            <span className="show-search-result-label">{DESCRIPTION_SHOW_SEARCH_RESULT}</span>
            <i
              className="svg-icon-blue"
              style={{
                backgroundImage: `url('${ICON_URLS.notes}')`
              }}
            ></i>
          </button>
        </div>
      )}

      {/* モバイル・タブレットのみ表示する、長押しポップアップ表示のためのボタン cssで制御 */}
      <div className="show-longpress">
        <button
          type="button"
          className="open-longpress-btn"
          onClick={openLongPressAtMapCenter}
        >
          <i
            className="svg-icon-black"
            style={{
              backgroundImage: `url('${ICON_URLS.keyboardArrowUp}')`
            }}
          ></i>
        </button>

      </div>
    </div>
  );
};

export default MobileActions;